import useLoading from "../../../../Hooks/useLoading";
import { OpportunitiesPanelsCommentsModel } from "../../../../Models/OpportunitiesPanelsModel";
import Loader from "../../../../Components/Shared/Loader";
import { useContext, useEffect, useState } from "react";
import { formatOnlyDate } from "../../../../Utils/DateFormat";
import { FaEdit, FaPencilAlt, FaTrash } from "react-icons/fa";
import useModal from "../../../../Hooks/useModal";
import ModalDelete from "../../../../Components/Shared/ModalDelete";
import { AuthContext } from '../../../../Contexts/AuthContext'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { Typography, Form, Button, Input } from 'antd';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";


interface IEditOpportunitiesPanelsCommentsModelProps {
    panelComments: OpportunitiesPanelsCommentsModel;
    index: number;
    length: number;
    deleteComments: (commentId: string) => Promise<void>;
    editComment: (commentId: string, comment: string) => Promise<void>;
    isAsc: boolean;
}

interface FormSubmitProps {
    comment: string;
    commentId: string;
}

const EditCommentsPanelsComponent = (props: IEditOpportunitiesPanelsCommentsModelProps) => {
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const { showModal, toggleShowModal } = useModal();
    const [deleteResponse, setDeleteResponse] = useState<boolean>(false);
    const [editCommentState, setEditCommentState] = useState<boolean>(false);
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [form] = Form.useForm();
    const { TextArea } = Input;



    const schema = yup.object().shape({
        comment: yup.string().max(2000, "Limite de caracteres excedido! Limite: 2000 Caracteres").required("Por favor, insira um Nome válido!")
    });

    const { register, handleSubmit, setValue, formState: { errors }, control } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (deleteResponse) {
            props.deleteComments(itemToDelete);
            setItemToDelete("");
            setDeleteResponse(false);
        }
    }, [deleteResponse])

    const EditPanelComment = async (data: any) => {
        try {
            toggleLoading(true);
            let comment = data.comment ?? "";
            let id = props.panelComments.id;
            props.editComment(id, comment);
            setEditCommentState(false);
            toggleLoading(false);
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }
    return (
        <div>
            <ModalDelete show={showModal} toggleShow={toggleShowModal} setResponse={setDeleteResponse} />
            {loading && <Loader />}
            {editCommentState ?
                <div className="commentCard mb-4" >

                    <div className="d-flex justify-content-between align-items-center m-4">
                        <Typography className="comment-text">{props.panelComments.createdBy}</Typography>
                        <Typography className="comment-text-date">{formatOnlyDate(props.panelComments.created.toString())}</Typography>
                    </div>
                    <div className="d-flex justify-content-between align-items-center me-2 ms-2 mb-2">

                        <Form
                            form={form}
                            layout="vertical"
                            className="w-100 mt-4"
                        >
                            <Form.Item>
                                <Controller
                                    name="comment"
                                    control={control}
                                    defaultValue={props.panelComments.comments}
                                    render={({ field }) => (
                                        <TextArea
                                            {...field}
                                            rows={3}
                                            placeholder={props.panelComments.comments == "" ? "Escreva aqui o seu comentário..." : ""}
                                        />

                                    )}
                                />
                            </Form.Item>
                            <div className="d-flex justify-content-end align-items-end mb-2 mr-2 me-2">
                                <Button type="primary" className="w-25" onClick={handleSubmit(data => EditPanelComment(data))} >
                                    <span className='ms-2 white'>Editar</span>
                                </Button>
                            </div>

                        </Form>
                    </div>
                </div>
                /* <form onSubmit={handleSubmit(data => EditPanelComment(data))} autoComplete='false' id="formOpportunitesPanels" method='POST'>
                    <div className="d-flex justify-content-between align-items-center me-2 ms-2 mb-2">
                        <textarea className='form-control' {...register("comment")}>{props.panelComments.comments}</textarea>
                    </div>
                    {(props.index === props.length - 1 && userEmail === props.panelComments.createdBy && !editCommentState) &&
                        <div className="align-self-end d-flex justify-content-center" style={{ gap: "8px", width: "160px" }}  >

                            <Button className="p-0" onClick={() => setEditCommentState(true)} style={{ border: 'none' }}>
                                <EditOutlined className="me-2 icon" />
                            </Button>
                            <Button className="p-0" onClick={() => { setItemToDelete(props.panelComments.id); toggleShowModal() }} style={{ border: 'none', color: "#CF1322" }}>
                                <DeleteOutlined className="me-2 icon" />
                            </Button>

                        </div>
                    }
                    <div className="d-flex justify-content-end align-items-end mb-2 mr-2 me-2">
                        <button type="submit" className="w-25 btn btn-primary white" >
                            <FaEdit className='' />
                            <span className='ms-2 white'>Editar</span>
                        </button>
                    </div>
                </form> */
                :
                <div className="commentCard mb-4" >

                    <div className="d-flex justify-content-between align-items-center m-4">
                        <Typography className="comment-text">{props.panelComments.createdBy}</Typography>
                        <Typography className="comment-text-date">{formatOnlyDate(props.panelComments.created.toString())}</Typography>
                    </div>

                    <div className="d-flex justify-content-between align-items-center text-comment-style mx-4">
                        <Typography className="comment-description"> {props.panelComments.comments}</Typography>
                    </div>

                    <div className="d-flex justify-content-center flex-column me-2 mt-4 mb-2" style={{ gap: '6px' }}>

                        {(((props.isAsc && props.index === props.length - 1) || (!props.isAsc && props.index == 0)) && userEmail === props.panelComments.createdBy && !editCommentState) &&
                            <div className="align-self-end d-flex justify-content-center" style={{ gap: "8px", width: "160px" }}  >

                                <Button className="p-0" onClick={() => setEditCommentState(true)} style={{ border: 'none' }}>
                                    <EditOutlined className="me-2 icon" />
                                </Button>
                                <Button className="p-0" onClick={() => { setItemToDelete(props.panelComments.id); toggleShowModal() }} style={{ border: 'none', color: "#CF1322" }}>
                                    <DeleteOutlined className="me-2 icon" />
                                </Button>

                            </div>
                        }
                        <div className={`d-flex justify-content-start align-items-center situation-panel align-self-end ${props.panelComments.result == 0 ? "color-reproved" : props.panelComments.result == 1 ? "color-approved" : "color-pedant"}`}>
                            <Typography className="text-situation-panel">Painel:
                                <span className="text-situation-span">
                                    {props.panelComments.result == 0 ?
                                        "  Reprovado" :
                                        props.panelComments.result == 1 ?
                                            "  Aprovado" :
                                            "  Pendente"
                                    }
                                </span>
                            </Typography>

                        </div>

                    </div>
                </div>}
        </div >
    )
}
export default EditCommentsPanelsComponent;